import React, { useState, useEffect } from 'react';

import '../index.css'
import { getHeptabaseData, getSiteConfig, onSiteDataChange } from '../constantFunction'


function Footer(props) {

    const [site, setSite] = useState(getSiteConfig());

    useEffect(() => {
        let alive = true
        getHeptabaseData().then((res) => {
            if (alive && res && res.site) setSite(res.site)
        }).catch(() => { })
        const unsubscribe = onSiteDataChange((event) => {
            if (event.type === 'update' && event.data && event.data.site) setSite(event.data.site)
        })
        return () => {
            alive = false
            unsubscribe()
        }
    }, [])

    // 只在后台设了页脚文字时渲染；没设就什么都不显示（旧版默认的 creativecommons.org 徽章外链图国内加载不出，只剩 alt 文字）
    if (site && site.footerText) {
        return <div className='footer'>{site.footerText}</div>
    }

    return null


}

export default Footer;
